export function noDuplicateEntries(entries) {
  const latestMap = new Map();

  for (const item of entries) {
    const key = item.label;
    const existing = latestMap.get(key);

    if (!existing || new Date(item.date) > new Date(existing.date)) {
      latestMap.set(key, item);
    }
  }

  return Array.from(latestMap.values());
}